import * as React from 'react';
import { HTMLAttributes, useContext } from 'react';

export interface AccordionContextProps extends HTMLAttributes<HTMLDivElement> {
  isExpanded: boolean;
  onClick: () => void;
}

const AccordionContext = React.createContext<AccordionContextProps | undefined>(undefined);

export const AccordionProvider = AccordionContext.Provider;
export default AccordionContext;

export function useAccordionContext() {
  const accordionConfig = useContext(AccordionContext);

  if (!accordionConfig) {
    throw new Error('context is not defined!!!!');
  }

  return accordionConfig;
}
